<h2 mat-dialog-title>{{ 'institution.persons.deactivate.title' | transloco }}</h2>
<mat-dialog-content>
	<p>
		{{
			'institution.persons.deactivate.confirmation'
				| transloco: { firstName: person.firstName, lastName: person.name, institutionName: institution.name }
		}}
	</p>
	<lvr-field [label]="'institution.persons.deactivate.double_check' | transloco">
		<mat-form-field lvrInput class="full-width">
			<input
				matInput
				[(ngModel)]="confirmationInput"
				[placeholder]="'institution.persons.deactivate.insert_name' | transloco: { lastName: person.name }"
			/>
		</mat-form-field>
	</lvr-field>
</mat-dialog-content>
<mat-dialog-actions class="actions-row">
	<lvr-button
		variant="secondary"
		[label]="'institution.persons.deactivate.cancel' | transloco"
		[type]="'button'"
		icon="disabled_by_default"
		mat-dialog-close
	></lvr-button>
	<lvr-button
		variant="primary"
		[label]="'institution.persons.deactivate.deactivate' | transloco"
		[type]="'button'"
		[disabled]="!isDeactivateEnabled()"
		[loading]="loading()"
		[loadingLabel]="'institution.persons.deactivate.deactivating' | transloco"
		(clicked)="deactivatePerson()"
		icon="delete"
	></lvr-button>
</mat-dialog-actions>
